import React, { useState, useEffect, useContext } from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

import dayjs from 'dayjs'

import _firebaseContext from '../../../contexts/firebaseContext'
import _appContext from '../../../contexts/appContext'

const useStyles = makeStyles(theme => ({
    historyWrapper: {
        maxHeight: 900,
        overflow: 'auto',
    },
    historyList: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    backdrop: {
        zIndex: 9999,
    },
    progress: {
        color: '#fff',
    },
    label: {
        // width: '100%',
    },
    previewWrapper: {
        width: '100%',
    },
    detailsWrapper: {
        paddingLeft: 25,
    },
}))

// const PrettyPrintJson = ({ data }) => {
//     return (
//         <div>
//             <pre>{JSON.stringify(data, null, 2)}</pre>
//         </div>
//     )
// }

const details = [
    { id: 'name', label: 'Наименование' },
    { id: 'auraColor', label: 'Аура трека' },
    { id: 'description', label: 'Описание' },
    { id: 'nightDescription', label: 'Описание ночного трека' },
    { id: 'planetType', label: 'Тип планеты' },
    { id: 'surfaceTexture', label: 'Тип поверхности' },
    { id: 'cloudTexture', label: 'Cсылка на текстуру облаков' },
    { id: 'disabled', label: 'Отключение планеты' },
    { id: 'trackUrl', label: 'Cсылка на трек' },
    { id: 'trackTimespan', label: 'Длительность трека в сек' },
    { id: 'nightTrackUrl', label: 'Cсылка на ночной трек' },
    { id: 'nightTrackTimespan', label: 'Длительность ночного трека в сек' },
    { id: 'trackStatus', label: 'Статус трека' },
]

const DetailsWrapper = ({ data }) => {
    const classes = useStyles()
    let fields = []

    if (data !== undefined) {
        fields = details.filter(detail => data[detail.id] !== undefined)
    }

    return (
        <div className={classes.detailsWrapper}>
            <Typography
                variant="body1"
                component="span"
                // color="textSecondary"
                className={classes.label}
            >
                Список изменений
            </Typography>
            {fields.map(field => (
                <div key={field.id}>
                    <Typography
                        variant="body2"
                        component="span"
                        color="textSecondary"
                        className={classes.label}
                    >
                        {field.label} {' - '}
                    </Typography>
                    <Typography variant="body1" component="span">
                        {data[field.id]}
                    </Typography>
                </div>
            ))}
        </div>
    )
}

function ListItemWrapper({ doc, locales }) {
    const classes = useStyles()
    const [expand, setExpand] = useState(false)

    const handleClick = () => {
        setExpand(!expand)
    }

    const events = {
        onCreate: 'Создание',
        onUpdate: 'Обновление',
        onDelete: 'Удаление',
    }
    const types = {
        tracks: 'Трек',
        planets: 'Планета',
        playlists: 'Плейлист',
    }
    const tracksLocales = {}
    if (locales && locales.length) {
        locales.forEach(locale => {
            types[`tracks_${locale}`] = 'Трек';
            tracksLocales[`tracks_${locale}`] = locale;
        });
    }

    return (
        <>
            <ListItem button onClick={handleClick}>
                <div className={classes.previewWrapper}>
                    <div>
                        <Typography
                            variant="body2"
                            component="span"
                            color="textSecondary"
                            className={classes.label}
                        >
                            Дата и время {' - '}
                        </Typography>
                        <Typography variant="body1" component="span">
                            {dayjs(doc.data.editDate.toDate()).format(
                                'DD/MM/YYYY HH:mm'
                            )}
                        </Typography>
                    </div>
                    <div>
                        <Typography
                            variant="body2"
                            component="span"
                            color="textSecondary"
                            className={classes.label}
                        >
                            Тип события {' - '}
                        </Typography>
                        <Typography variant="body1" component="span">
                            {events[doc.data.eventType]}
                        </Typography>
                    </div>
                    <div>
                        <Typography
                            variant="body2"
                            component="span"
                            color="textSecondary"
                            className={classes.label}
                        >
                            Тип объекта {' - '}
                        </Typography>
                        <Typography variant="body1" component="span">
                            {types[doc.data.objectType]}
                        </Typography>
                    </div>
                    {
                        types[doc.data.objectType] === 'Трек' && tracksLocales[doc.data.objectType] &&
                        <div>
                            <Typography
                                variant="body2"
                                component="span"
                                color="textSecondary"
                                className={classes.label}
                            >
                                Язык трека {' - '}
                            </Typography>
                            <Typography variant="body1" component="span">
                                {tracksLocales[doc.data.objectType]}
                            </Typography>
                        </div>
                    }
                    <div>
                        <Typography
                            variant="body2"
                            component="span"
                            color="textSecondary"
                            className={classes.label}
                        >
                            Автор {' - '}
                        </Typography>
                        <Typography variant="body1" component="span">
                            {doc.data.eventBy && doc.data.eventBy.displayName}
                        </Typography>
                    </div>
                </div>
                {expand ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={expand} timeout="auto" unmountOnExit>
                <DetailsWrapper data={doc.data.object.changes} />
                {/* <PrettyPrintJson data={doc.data.object} /> */}
            </Collapse>
            <Divider />
        </>
    )
}

export default function HistoryDialog({ open, onClose, planet, locales }) {
    const classes = useStyles()
    const [history, setHistory] = useState([])

    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    useEffect(() => {
        const fetchingState = firebaseContext.data.fetchingState['history']

        if (fetchingState) {
            appContext.startLoading()
        } else {
            appContext.endLoading()
        }
    })

    const getHistory = () =>
        firebaseContext
            .getHistory(planet.id)
            .then(history => setHistory(history))

    useEffect(() => {
        getHistory()
    }, [])

    return (
        <>
            {
                !firebaseContext.data.fetchingState['history'] &&
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={open}
                    onClose={onClose}
                    className={classes.historyWrapper}
                >
                    <DialogTitle>История редактирования планеты</DialogTitle>
                    <DialogContent>
                        {history === undefined || history.length === 0 ? (
                            <Typography>Пока нет истории</Typography>
                        ) : (
                            <List className={classes.historyList}>
                                {history.map(doc => (
                                    <ListItemWrapper key={doc.id} doc={doc} locales={locales}/>
                                ))}
                            </List>
                        )}
                    </DialogContent>
                </Dialog>
            }
        </>
    )
}
